import expenseQueryMatch from '@/function/expense/expense.query.match';
import { expenseState } from '@/function/expense/expense.state';
import type { TypeExpense } from '@/types/expense/types.expense';
import type { TypeExpenseQuery, TypeExpenseTotals } from '@/types/expense/types.expense.query';

const contribution = (expense: TypeExpense, today: string): TypeExpenseTotals => {
    const state = expenseState(expense, today);
    return {
        count: 1,
        totalCents: expense.totalCents,
        openCents: state === 'paid' ? 0 : expense.totalCents,
        paid: state === 'paid' ? 1 : 0,
        due: state === 'due' ? 1 : 0,
        overdue: state === 'overdue' ? 1 : 0,
    };
};

const KEYS: (keyof TypeExpenseTotals)[] = ['count', 'totalCents', 'openCents', 'paid', 'due', 'overdue'];

export function expenseTotalsDelta(
    before: TypeExpense | null | undefined,
    after: TypeExpense | null,
    query: TypeExpenseQuery,
): TypeExpenseTotals | null {
    const was = before ? expenseQueryMatch(before, query) : false;
    const is = after ? expenseQueryMatch(after, query) : false;
    if (was === null || is === null) return null;
    if (before === undefined && is) return null;

    const delta: TypeExpenseTotals = { count: 0, totalCents: 0, openCents: 0, paid: 0, due: 0, overdue: 0 };
    if (was && before) {
        const out = contribution(before, query.today);
        for (const key of KEYS) delta[key] -= out[key];
    }
    if (is && after) {
        const add = contribution(after, query.today);
        for (const key of KEYS) delta[key] += add[key];
    }
    return delta;
}

export default expenseTotalsDelta;
